/**
 * Admin Emails — single source of truth.
 * Used by web AuthContext, mobile AuthContext, community pages, and backend.
 *
 * Anyone with an @wanderaway.ai email is also auto-admin (domain check).
 */

export const ADMIN_EMAILS = [
  // Founders / core team
  'pmaddenstoscano@gmail.com',
  'mintzzoe1014@gmail.com',
  'mintzlinda@gmail.com',
  'penny@wiserock.com',
  'jpsmtos@gmail.com',
  'feuser.lucas@gmail.com',
  // Service / domain emails
  'pedro@getwander.app',
  'admin@getwander.app',
  'hello@arrivotravel.ai',
];

/** Super-admin emails — access to analytics dashboard, admin portal, budget tracker. */
export const SUPER_ADMIN_EMAILS = [
  'pmaddenstoscano@gmail.com',
  'amintz812@gmail.com',
];

/** Domains that auto-grant admin access (no need to list individual emails). */
export const ADMIN_DOMAINS = ['arrivotravel.ai', 'wanderaway.ai'];

/**
 * Check if an email is an admin.
 * @param {string} email
 * @returns {boolean}
 */
export function isAdminEmail(email) {
  if (!email) return false;
  const lower = email.toLowerCase();
  return ADMIN_EMAILS.includes(lower) || ADMIN_DOMAINS.some(d => lower.endsWith(`@${d}`));
}

/**
 * Check if an email is a super-admin (analytics, admin dashboard, budget access).
 * @param {string} email
 * @returns {boolean}
 */
export function isSuperAdminEmail(email) {
  if (!email) return false;
  return SUPER_ADMIN_EMAILS.includes(email.toLowerCase());
}
